import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'

import './i18n'
import AppAdmin from './AppAdmin.tsx'
import './index.css'

// (2026-10-08 사장님: 서버 재시작/빌드 후 관리자 페이지 멈춤) 새 빌드로 청크 이름이 바뀐 뒤 옛 index.html 이 사라진 청크를
// 불러오다 실패하면(Failed to fetch dynamically imported module) 자동으로 한 번만 새로고침해 최신 index.html 을 받는다.
window.addEventListener('vite:preloadError', (e: Event) => {
  try {
    const key = 'admin_chunk_reload_at'
    const last = Number(sessionStorage.getItem(key) || 0)
    if (Date.now() - last > 15000) {   // 15초 내 반복 새로고침 방지(루프 차단)
      sessionStorage.setItem(key, String(Date.now()))
      e.preventDefault()
      window.location.reload()
    }
  } catch { /* noop */ }
})
import { useTranslation } from 'react-i18next'

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

// 개발 환경에서 StrictMode로 인한 중복 호출 방지 옵션
const isDevelopment = import.meta.env.DEV
const AppWrapper = isDevelopment ? React.Fragment : React.StrictMode

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AppWrapper>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppAdmin />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              className: 'toast-custom',
              style: {
                background: 'rgba(17, 24, 39, 0.9)',
                color: '#f9fafb',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(75, 85, 99, 0.3)',
              },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </AppWrapper>,
)